import { render, staticRenderFns } from "./BlessingBag.vue?vue&type=template&id=68f0588a&scoped=true"
import script from "./BlessingBag.vue?vue&type=script&lang=js"
export * from "./BlessingBag.vue?vue&type=script&lang=js"
import style0 from "./BlessingBag.vue?vue&type=style&index=0&id=68f0588a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f0588a",
  null
  
)

export default component.exports